export type KVMeasurementSegmentJSON = {
  measurementSegmentStartPosition: string
  measurementSegmentEndPosition: string
  measurementSegmentId: string
  measurementSegmentType: string
}

export class KVMeasurementSegment {
  measurementSegmentStartPosition: string
  measurementSegmentEndPosition: string
  measurementSegmentId: string
  measurementSegmentType: string
  constructor() {
    this.measurementSegmentStartPosition = ''
    this.measurementSegmentEndPosition = ''
    this.measurementSegmentId = ''
    this.measurementSegmentType = 'StraightLine'
  }

  static fromJSON(json: KVMeasurementSegmentJSON): KVMeasurementSegment {
    const measurementSegment = new KVMeasurementSegment()
    if (json.measurementSegmentStartPosition)
      measurementSegment.measurementSegmentStartPosition =
        json.measurementSegmentStartPosition
    if (json.measurementSegmentEndPosition)
      measurementSegment.measurementSegmentEndPosition =
        json.measurementSegmentEndPosition
    if (json.measurementSegmentId)
      measurementSegment.measurementSegmentId = json.measurementSegmentId
    if (json.measurementSegmentType)
      measurementSegment.measurementSegmentType = json.measurementSegmentType
    return measurementSegment
  }

  static toJSON(
    measurementSegment: KVMeasurementSegment
  ): KVMeasurementSegmentJSON {
    return {
      measurementSegmentStartPosition:
        measurementSegment.measurementSegmentStartPosition,
      measurementSegmentEndPosition:
        measurementSegment.measurementSegmentEndPosition,
      measurementSegmentId: measurementSegment.measurementSegmentId,
      measurementSegmentType: measurementSegment.measurementSegmentType,
    }
  }
}
